// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.

import { ModifyTrailingStopOrder } from "../order-modify/ModifyTrailingStopOrder.js"
import { OrderTypeBase } from "./OrderTypeBase.js";
import { OrderType } from "../../../../Utils/Trading/OrderType.js"
import { RulesSet } from "../../../../Utils/Rules/RulesSet.js"
import { TrailingStopOrderEdit } from "../order-edit/TrailingStopOrderEdit.js";

export let TrailingStopOrderType = function ()
{
    OrderTypeBase.call(this, TrailingStopOrderEdit, ModifyTrailingStopOrder)
}

TrailingStopOrderType.prototype = Object.create(OrderTypeBase.prototype)

TrailingStopOrderType.prototype.id = function () 
{
    return OrderType.TrailingStop
}

TrailingStopOrderType.prototype.localizationKey = function ()
{
    return 'Tr. stop'
}

TrailingStopOrderType.prototype.IsSupported = function (params)
{
  let allowedByRule = params.checkRuleForTrailingStopOrder
    ? this.checkRuleForAccount(params.account, RulesSet.FUNCTION_TRAILING_STOP, params.instrument)
    : true
  
  return allowedByRule && OrderTypeBase.prototype.IsSupported.call(this, params)
}